.newsletter {
  padding: 8px 0 64px;
}

.newsletter__band {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW (accent) */
  border: 2px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  border-radius: 18px;
  padding: 26px 32px;
  text-align: center;
  box-shadow: var(--plume-shadow-newsletter, 1px 2px 10px 0 rgba(89, 84, 78, 0.12));
}

.newsletter__band ::selection {
  background: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  color: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
}

.newsletter__icon {
  flex: none;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-complementary-yellow);
}

.newsletter__icon svg {
  width: 21px;
  height: 21px;
}

.newsletter__text {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  margin: 0;
}

.newsletter__text a {
  color: var(--color-primary-grey-900);
  font-weight: 800;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-thickness: 2px;
}

@media (max-width: 560px) {
  .newsletter__band {
    flex-direction: column;
  }
}
